var TrackingHelper;

TrackingHelper = (function() {
  function TrackingHelper() {
    this.recordedFirstPage = false;
  }

  TrackingHelper.prototype.pageReady = function() {
    if (this.recordedFirstPage) {
      return;
    }
    if (!Groupon.Performance) {
      return;
    }
    Groupon.Performance.pageReady();
    return this.recordedFirstPage = true;
  };

  return TrackingHelper;

})();

module.exports = TrackingHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3RyYWNraW5nLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FkY2FiYWxsZXJvL25hcGlzdHJhbm8vYnVpbGQvMTQ5MjQ2Nzk3NTM3OS0zNzk1Mi9zdGFnaW5nLTIwMTcuMDQuMTdfMjIuMTUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvaGVscGVycy90cmFja2luZy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBTTtFQUNTLHdCQUFBO0lBQ1gsSUFBQyxDQUFBLGlCQUFELEdBQXFCO0VBRFY7OzJCQUdiLFNBQUEsR0FBVyxTQUFBO0lBQ1QsSUFBRyxJQUFDLENBQUEsaUJBQUo7QUFBMkIsYUFBM0I7O0lBQ0EsSUFBRyxDQUFJLE9BQU8sQ0FBQyxXQUFmO0FBQWdDLGFBQWhDOztJQUVBLE9BQU8sQ0FBQyxXQUFXLENBQUMsU0FBcEIsQ0FBQTtXQUVBLElBQUMsQ0FBQSxpQkFBRCxHQUFxQjtFQU5aOzs7Ozs7QUFRYixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
